import React, { useState } from "react";
import "./FaqContent.css";
import FaqData from "../../data/FAQsData.json";
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
//.import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import usePagination from "./Pagination";
import Typography from "@mui/material/Typography";
import FloatIcon from "../FloatIcons/FloatIcons";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
}));

function FaqContent() {
  const classes = useStyles();
  const [page, setPage] = useState(1);
  const PER_PAGE = 8;
  const count = Math.ceil(FaqData.length / PER_PAGE);
  const _DATA = usePagination(FaqData, PER_PAGE);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredresults, setFilteredResults] = useState([FaqData]);
  const [expanded, setExpanded] = useState(false);
  const handleChange = (e, p) => {
    setPage(p);
    _DATA.jump(p);
  };
  const toggleQuestion = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const searchHandler = (e) => {
    setSearchTerm(e.target.value);
    if (searchTerm !== "") {
      const filteredData = FaqData.filter((item) => {
        return Object.values(item)
          .join("")
          .toLowerCase()
          .includes(searchTerm.toLowerCase());
      });
      setFilteredResults(filteredData);
    }
  };

  return (
    <>
      {/* Float Icon Start */}
      <div className="floatIconsContainer">
        <FloatIcon />
      </div>
      {/* Float Icon End */}
      <div className="faqBanner">
        <img
          src="/images/faq/faq-banner.png"
          alt="Banner"
          className="LearningBanner"
        />
        <h2 id="ourLeadBannerText"></h2>
        {/* <Floaticons /> */}
      </div>

      <div className="faq_main-container">
        <div className="main_faq_header">
          <h2 className="pageHeading">FAQs</h2>
          <div id="search_container">
            <div className="search_img_container">
              <img src="images/faq/Icon-ionic-ios-search.png" alt="search" />
            </div>
            <TextField
              className="searchLabel"
              id="outlined-basic"
              variant="outlined"
              fullWidth
              label="Search..."
              onChange={searchHandler}
            />
          </div>
        </div>
        <div id="accordion-section">
          <div className={classes.root}>
            {searchTerm.length > 0
              ? filteredresults.map((item, i) => {
                  return (
                    <Accordion key={i}>
                      <AccordionSummary
                        className="accordionTitle"
                        aria-controls="panel1bh-content"
                        id="panel1bh-header"
                      >
                        <h3>{item.Question}</h3>
                      </AccordionSummary>
                      <AccordionDetails>
                        <p
                          dangerouslySetInnerHTML={{ __html: item.Answer }}
                        ></p>
                      </AccordionDetails>
                    </Accordion>
                  );
                })
              : _DATA.currentData().map((item, i) => {
                  return (
                    <Accordion
                      expanded={expanded === i}
                      onChange={toggleQuestion(i)}
                      key={i}
                    >
                      <AccordionSummary
                        className="accordionTitle"
                        aria-controls="panel1bh-content"
                        id="panel1bh-header"
                      >
                        <h3>
                          <img src="images/faq/arrow.png" alt="" />{" "}
                          {item.Question}
                        </h3>
                      </AccordionSummary>
                      <AccordionDetails>
                        <p
                          dangerouslySetInnerHTML={{ __html: item.Answer }}
                        ></p>
                      </AccordionDetails>
                    </Accordion>
                  );
                })}

            <div className="paginationRow">
              <div id="pagination_container">
                <Stack spacing={2} className="paginationNav">
                  <Pagination
                    count={count}
                    page={page}
                    onChange={handleChange}
                  />
                </Stack>
              </div>
              <Stack>
                <Typography className="pageNumber">
                  Page: {page} of {count}
                </Typography>
              </Stack>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default FaqContent;
